import { PrimaryControlsStripLeading } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.back";
import { ToolbarIconButton } from "@-/dev.improve.haniverse.components.ui.toolbar.button.icon";
import { View } from "@-/com.npmjs.react-native";

/**
 * What the Characters toolbar's leading slot shows while the catalog is still loading — a single
 * disabled spinner button in place of the sort / filter / view controls, matching the Primitives
 * index route's top-left spinner.
 *
 * The real controls are hidden rather than disabled in place: with the filter facts still pending,
 * opening the filter menu would act on a list that has not been built yet, and a full row of live
 * affordances over an empty list reads as "nothing here" instead of "still loading". Swapping in
 * one spinner keeps the toolbar's footprint (and the list's reserved top padding)
 * unchanged, so nothing shifts when the actions arrive.
 */
export function CharactersToolbarLoadingActions() {
  return (
    <PrimaryControlsStripLeading>
      <View className="flex-row items-center gap-1" pointerEvents="box-none">
        <ToolbarIconButton
          accessibilityLabel="Loading characters"
          disabled
          isLoading
          name="MdRefresh"
          size="menu"
        />
      </View>
    </PrimaryControlsStripLeading>
  );
}
